export const EXAM_TYPES = Object.freeze({
    GMAT: 'gmat',
    GRE: 'gre',
    IELTS: 'ielts',
    TOEFL: 'toefl'
});

export const SUBJECT_TITLES = Object.freeze({
    QUANT: 'Quantitative',
    VERBAL: 'Verbal'
});

export const SIGNUP_PLATFORMS = Object.freeze({
    YOCKET: 1,
    SUPERTEST: 2
});

export const SUBJECTS = Object.freeze({
    QUANT: 'quant',
    VERBAL: 'verbal',
    DATA_INSIGHTS: 'dataInsights'
});

export const ERROR_MESSAGES = Object.freeze({
    LIVE_TEST_NOT_STARTED: 'Live Test to be taken between',
    GRE_LIVE_TEST_SESSIONS_EXCEEDED:
        'User has exceed the limit a User can given All India GRE Live Tests',
    GRE_LIVE_TEST_LIMIT_EXCEEDED:
        'You’ve already attempted the maximum number of All India GRE Live Tests allowed.'
});
